export const environment = {
  production: false,
  apiURL: 'https://devapi.digitalbuyersmanager.com/',
  googleMapsApiKey: 'AIzaSyAcYQeSCgfsAXLOPWgnk3XLqZENOw64MAM',
};
